import _JSXStyle from "styled-jsx/style";
import React from 'react';
import { SortableHandle } from 'react-sortable-hoc';
import Icon from "../Icon/Icon";
export default function withDragHandler(WrappedComponent) {
  var useDefault = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (useDefault) {
    return SortableHandle(function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "jsx-2894711909" + " " + "rg-DragHandler me-3 align-self-stretch"
      }, /*#__PURE__*/React.createElement("span", {
        className: "jsx-2894711909" + " " + "d-flex flex-column align-items-center justify-content-center h-100 pe-1"
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "grip-vertical",
        size: "lg"
      }))), /*#__PURE__*/React.createElement(_JSXStyle, {
        id: "2894711909"
      }, ".rg-DragHandler.jsx-2894711909{cursor:-webkit-grab;cursor:-moz-grab;cursor:grab;opacity:0.4;}.rg-DragHandler.jsx-2894711909:hover{opacity:0.8;}"));
    });
  }

  return SortableHandle(WrappedComponent);
}